module.exports = require('./lib/immutable')



//////////////////
// WEBPACK FOOTER
// ./~/redux-form/immutable.js
// module id = 672
// module chunks = 0